/* eslint-disable */
import axios from "axios";
import store from "@/store";
import moment from "moment";
import customModal from "../customModal/customModal.vue";

export default {
  name: "ReportViewModal",

  components: {
    customModal,
  },
  props: {
    data: { type: Object, required: false, },
    fromPage: {
      type: String,
      default: ""
    }
  },


  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,

      resolvedData: null,
      loading: false,
      error: null,
      showDataReference: false,
      defaultdate: "",
    };
  },

  async mounted() {
    this.defaultdate = localStorage.getItem("dateformat");
    await this.fetchReportDetails();
  },

  methods: {
    async fetchReportDetails() {
      this.loading = true;
      let idtoken = store.getters.getIdToken;
      let riskScoreId = this.data?.riskScore?.[0]?.id;
      if (!riskScoreId) {
        riskScoreId = this.data?.riskScoreId;
      }
      try {
        const response = await axios.get(
          `${this.baseurl}/forms/rbqmaudit/getrbqmauditlogs?id=${riskScoreId}`, {
          headers: {
            Authorization: `Bearer ${idtoken}`,
            "Content-Type": "application/json"
          }
        }

        );

        this.resolvedData = response.data;

        console.log("API response:", this.resolvedData);
      } catch (err) {
        console.error("Failed to fetch report details:", err);
        this.error = "Unable to load report details";
      } finally {
        this.loading = false;
      }
    },

    closeModal() {
      this.$emit("closeModal");
    },
    formatdatetime(data) {
      if (data) {
        return moment(data).format(this.defaultdate)
      }
    },
    getDynamicKeys(ref) {
      return Object.keys(
        ref.queryData || ref.scheduleData || {}
      );
    },

    getAllDynamicKeys() {
      const keys = new Set();
      const references = this.resolvedData?.dataReference || [];
      references.forEach(ref => {
        if (!ref.fieldName) {
          const obj = ref.scheduleData || ref.queryData || {};
          Object.keys(obj).forEach(key => keys.add(key));
        }
      });
      return Array.from(keys);
    },
    formatColumnHeader(key) {
      return key.replace(/([A-Z])/g, ' $1').trim();
    },
    hasScheduleData() {
      return (this.resolvedData?.dataReference || []).some(ref => ref.scheduleData);
    },
    hasFieldNames() {
      return (this.resolvedData?.dataReference || []).some(ref => ref.fieldName);
    },
    formatCellValue(value) {
      if (value == null || value === '') return '-';
      const parsed = moment(value);
      if (parsed.isValid()) {
        if (value.toString().includes(':')) {
          return moment(value).format(this.defaultdate );
        }
        return moment(value).format(this.defaultdate);
      }
      return value;
    },
  },
};
